import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Injectable, Injector, NgModule, Provider } from '@angular/core';
import { Router } from '@angular/router';
import {
    MsalBroadcastService,
    MsalGuard,
    MsalGuardConfiguration,
    MsalInterceptor,
    MsalInterceptorConfiguration,
    MsalService, MSAL_GUARD_CONFIG,
    MSAL_INSTANCE,
    MSAL_INTERCEPTOR_CONFIG
} from '@azure/msal-angular';
import {
    BrowserCacheLocation,
    InteractionType,
    IPublicClientApplication,
    PublicClientApplication
} from '@azure/msal-browser';
import { Store } from '@ngxs/store';
import { LogLevel } from 'msal';
import { LocalStorageService } from 'ngx-webstorage';
import { AppInitializerService } from 'src/app/services/app-initializer/app-initializer.service';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { UserService } from 'src/app/services/user/user.service';
import { Utilities } from 'src/app/services/utilities';
import { environment } from 'src/environments/environment';


const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1; // Remove this line to use Angular Universal

export function loggerCallback(logLevel: LogLevel, message: string) {

    1
}


@Injectable({ providedIn: 'root' }) export class TestService {
    // constructor(private router: Router){}
}

export function MSALInstanceFactory(initializerService: AppInitializerService): IPublicClientApplication {

    // Use cached clientId if we have one, otherwise default to BeneLynk WebApp (108***-****-**)
    // This is safe b/c non-BeneLynk WebApp assigned users will NOT be able to acquire a toekn given our direct assignment requirement

    return new PublicClientApplication({
        auth: {
            clientId: initializerService.clientId || environment.adal.clientId,
            navigateToLoginRequestUrl: true,
            authority: `https://login.microsoftonline.com/${environment.adal.tenant}`,
            redirectUri: window.location.origin,
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
            storeAuthStateInCookie: isIE, // set to true for IE 11. Remove this line to use Angular Universal
        },
        system: {
            loggerOptions: {
                loggerCallback,
                logLevel: LogLevel.Verbose,
                piiLoggingEnabled: false
            }
        }
    });
}

export function MSALInterceptorConfigFactory(configurations: ConfigurationService): MsalInterceptorConfiguration {

    console.log(`configurations.snapshot => `, configurations.snapshot);

    const protectedResourceMap = new Map<string, Array<string>>();
    protectedResourceMap.set('https://graph.microsoft.com/v1.0/*', ['user.read']);
    protectedResourceMap.set(`${configurations.baseUrl || Utilities.baseUrl()}epmp/*`, [environment.adal.customScope]);
    protectedResourceMap.set(`${AppInitializerService.configuration.webAppApiBaseUrl}*`, [environment.adal.customScope]);

    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap
    };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {

    return {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: [environment.adal.customScope]
        },
        loginFailedRoute: '/login-failed'
    };
}


export const SecurityProviders: Provider[] = [
    {
        provide: HTTP_INTERCEPTORS,
        useClass: MsalInterceptor,
        multi: true
    },
    {
        provide: MSAL_INTERCEPTOR_CONFIG,
        useFactory: MSALInterceptorConfigFactory,
        deps: [ConfigurationService]
    },
    {
        provide: MSAL_INSTANCE,
        useFactory: MSALInstanceFactory,
        deps: [AppInitializerService, LocalStorageService]
    },
    {
        provide: MSAL_GUARD_CONFIG,
        useFactory: MSALGuardConfigFactory
    },

    MsalService,
    MsalGuard,
    MsalBroadcastService
];

@NgModule({
    imports: [
        CommonModule,
    ],
    providers: SecurityProviders
})
export class SecurityModule {

}
